export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function truncate(str, length = 120) {
  if (!str) return '';
  return str.length <= length ? str : str.slice(0, length).trimEnd() + '…';
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function getInitials(name) {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function categoryColor(category) {
  const map = {
    'Full Stack': 'badge-blue',
    Frontend: 'badge-purple',
    Backend: 'badge-green',
    IoT: 'badge-orange',
    'Hardware + Software': 'badge-orange',
    'Product Design': 'badge-purple',
    'Enterprise Software': 'badge-blue',
    AgriTech: 'badge-green',
    EdTech: 'badge-blue',
    'E-Commerce': 'badge-purple',
    'Security Systems': 'badge-orange',
    'Web Development': 'badge-blue',
    Other: 'badge-blue',
  };
  return map[category] || 'badge-blue';
}

export function statusColor(status) {
  const map = {
    Completed: 'badge-green',
    'In Progress': 'badge-blue',
    'In Production': 'badge-purple',
    Archived: 'badge-orange',
  };
  return map[status] || 'badge-blue';
}
